import { z } from 'zod';
import { IsoDateTimeSchema } from './ids.js';
import { ErrorCodeSchema } from './error-codes.js';
/**
 * Every success response's envelope (03-API-CONTRACT.md §0):
 * `{ data, meta: { requestId, serverTime } }`. `serverTime` is on EVERY
 * response, never optional — the PWA uses it to maintain its clock offset (D-10).
 */
export function envelope(dataSchema) {
    return z.object({
        data: dataSchema,
        meta: z.object({
            requestId: z.string().min(1),
            serverTime: IsoDateTimeSchema,
        }),
    });
}
/**
 * The paginated variant: `data` is an array of items, and `meta` additionally
 * carries `page`, `pageSize`, `total`, `totalPages`.
 */
export function paginatedEnvelope(itemSchema) {
    return z.object({
        data: z.array(itemSchema),
        meta: z.object({
            requestId: z.string().min(1),
            serverTime: IsoDateTimeSchema,
            page: z.int().min(1),
            pageSize: z.int().min(1).max(200),
            total: z.int().min(0),
            totalPages: z.int().min(0),
        }),
    });
}
/**
 * The error envelope (03-API-CONTRACT.md §0). `code` is the closed,
 * never-localized machine code; `message` is localized to the caller.
 * `details` is optional structured context (e.g. `{ windowStart, windowEnd }`).
 */
export const ErrorEnvelopeSchema = z.object({
    error: z.object({
        code: ErrorCodeSchema,
        message: z.string().min(1),
        details: z.unknown().optional(),
        requestId: z.string().min(1),
    }),
});
//# sourceMappingURL=envelope.js.map